<script>
import { defineComponent, h } from 'vue';
import Facebook from './channels/Facebook.vue';
import Website from './channels/Website.vue';
import Twitter from './channels/Twitter.vue';
import Api from './channels/Api.vue';
import Email from './channels/Email.vue';
import Sms from './channels/Sms.vue';
import Whatsapp from './channels/Whatsapp.vue';
import Line from './channels/Line.vue';
import Telegram from './channels/Telegram.vue';
import Instagram from './channels/Instagram.vue';
import Tiktok from './channels/Tiktok.vue';
import Voice from './channels/Voice.vue';
// FORK_PATCH_BEGIN: channel-catalog
import { isInboxChannelVisible } from 'custom/dashboard/helper/channelCatalog';
// FORK_PATCH_END: channel-catalog

const channelViewList = {
  facebook: Facebook,
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  whatsapp: Whatsapp,
  line: Line,
  telegram: Telegram,
  instagram: Instagram,
  tiktok: Tiktok,
  voice: Voice,
};

export default defineComponent({
  name: 'NewChannelView',
  props: {
    channelName: {
      type: String,
      required: true,
    },
  },
  // FORK_PATCH_BEGIN: channel-catalog
  // Block deep-links to hidden catalog channels (screen-recording / rollout gates).
  created() {
    if (!isInboxChannelVisible(this.channelName)) {
      // eslint-disable-next-line no-console
      console.debug('[channel_catalog] redirect hidden channel', {
        channel: this.channelName,
      });
      this.$router.replace({
        name: 'settings_inbox_new',
        params: { accountId: this.$route.params.accountId },
      });
    }
  },
  // FORK_PATCH_END: channel-catalog
  render() {
    // FORK_PATCH_BEGIN: channel-catalog
    if (!isInboxChannelVisible(this.channelName)) {
      return null;
    }
    // FORK_PATCH_END: channel-catalog
    const ChannelComponent = channelViewList[this.channelName];
    return ChannelComponent ? h(ChannelComponent) : null;
  },
});
</script>
